import axios from 'axios';

let baseUrl = (process.env.MIX_APP_URL || '') + '/api/'

let base = axios.create({
	baseURL: baseUrl
});
export default base;

